import styled from 'styled-components';
var Divider = /*#__PURE__*/styled.div.withConfig({
  displayName: "divider__Divider",
  componentId: "ijfrqk-0"
})(["width:100%;height:1px;margin-top:", ";margin-bottom:", ";background:", ";"], p => "".concat(p.margin ? "".concat(p.margin, "px") : '0px'), p => "".concat(p.margin ? "".concat(p.margin, "px") : '0px'), p => p.color ? p.theme.colors[p.color] : p.theme.colors.white);
export default Divider;